import { apiEndpoints } from 'shared/model/apiEndpoints'

import {
  GetMeResponse,
  Login,
  LoginResponse,
  LogoutResponse,
  ModulesResponse,
} from 'modules/Auth/types/api'

import { globalAPI } from 'shared/config/redux/api/global'

export const authApi = globalAPI.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, Login>({
      query: (body) => ({
        url: apiEndpoints.login,
        method: 'POST',
        body,
      }),
    }),

    logout: build.query<LogoutResponse, void>({
      query: () => ({
        url: apiEndpoints.logout,
      }),
    }),

    getMe: build.mutation<GetMeResponse, void>({
      query: () => ({
        method: 'GET',
        url: '/users/me',
      }),
    }),
    getModules: build.query<ModulesResponse, void>({
      query: () => ({
        url: apiEndpoints.modules,
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useGetMeMutation,
  useLazyLogoutQuery,
  useGetModulesQuery,
} = authApi
